function isTimestampLike(value) {
    return typeof value === "object" && value !== null && typeof value.toDate === "function";
}
export function reviveTimestamps(value) {
    if (isTimestampLike(value))
        return value.toDate();
    if (Array.isArray(value))
        return value.map(reviveTimestamps);
    if (value instanceof Date)
        return value;
    if (typeof value === "object" && value !== null) {
        return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, reviveTimestamps(v)]));
    }
    return value;
}
export function fromStored(schema, data, path) {
    const parsed = schema.safeParse(reviveTimestamps(data));
    if (!parsed.success) {
        throw new Error(`stored document ${path} does not match its schema: ${parsed.error.message}`);
    }
    return parsed.data;
}
//# sourceMappingURL=convert.js.map